"use client";

import { createContext, type ReactNode, useContext } from "react";
import { useSessionReader } from "@/hooks/use-session-reader";
import type { Reader } from "@/lib/reader";

const ReaderContext = createContext<Reader | undefined>(undefined);

export function ReaderProvider({ children }: { children: ReactNode }) {
  const reader = useSessionReader();
  return (
    <ReaderContext.Provider value={reader}>{children}</ReaderContext.Provider>
  );
}

export function useReader(): Reader | undefined {
  return useContext(ReaderContext);
}
